module.exports = __webpack_public_path__ + "static/media/mobileholder.b67b9e0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Modals/Holders Modal/mobileholder.png
// module id = 781
// module chunks = 0